import React from "react";
import { Form, Select, Text } from "react-form";

export default ({ onSearchFormSubmit }) => {
  const searchOptions = [{ label: "By Name", value: "name" }];
  return (
    <Form onSubmit={onSearchFormSubmit} defaultValues={{ search_by: "name" }}>
      {formApi => (
        <form method="post" onSubmit={formApi.submitForm}>
          <p className="control is-fullwidth is-hidden-tablet">
            <span className="select is-fullwidth">
              <Select field="search_by" placeholder=" " options={searchOptions} />
            </span>
          </p>
          <div className="field has-addons">
            <p className="control is-hidden-mobile">
              <span className="select">
                <Select field="search_by" placeholder=" " options={searchOptions} />
              </span>
            </p>
            <p className="control is-expanded">
              <Text
                field="search_term"
                placeholder={`Find promotion type by ${formApi.values.search_by}`}
                className="input"
                required
              />
            </p>
            <p className="control">
              <button type="submit" className="button is-info">
                Search
              </button>
            </p>
          </div>
        </form>
      )}
    </Form>
  );
};



// WEBPACK FOOTER //
// ./src/pages/PromotionType/Index/SearchForm.js